import NameInput from "./NameInput";

function LoginPage() {
  return (
    <div className="centerContainer height100">
      <div>
        <h1 className="center">Quixx</h1>
        <NameInput />
      </div>
    </div>
  );
}

export default LoginPage;
